import InputLabel from "@material-ui/core/InputLabel"
import FormControl from "@material-ui/core/FormControl"
import * as React from "react"
import { getGeoVariableArray, getJsonGroup } from "../data/json-provider"
import { actions, AppState } from "../data/redux-state"
import { globalStore } from "./Index"
import { FormattedMessage, IntlShape, useIntl } from "gatsby-plugin-intl"
import selectInfoLink from "../utils/selectInfoLink"
// @ts-ignore
import infoIcon from "../assets/images/info.png"
import { GenericSelect } from "./GenericSelect"
import { IndicatorClass } from "../data/indicator-class"

export function extractVersionFromGeoVariable(
  geoVariable: string | null
): string | null {
  if (!geoVariable) {
    return null
  }
  const versionMatch = geoVariable.match(/_([^_]+)\.json$/)
  return versionMatch ? versionMatch[1] : null
}

export function extractOptionalTranslation(args: {
  parentKey: string
  subKey: string
  intl: IntlShape
}) {
  if (!args.intl) {
    return args.subKey
  }
  let subKey = args.subKey
  const id = args.parentKey + "." + subKey
  if (args.intl.messages[id] !== undefined) {
    return args.intl.formatMessage({ id, defaultMessage: id })
  } else {
    console.error("Missing translation '" + id + "'")
    return args.subKey
  }
}

export function getGeoVariableName(
  indicatorClass: IndicatorClass,
  geoVariable: string
) {
  return getJsonGroup(indicatorClass)[geoVariable]
}

export function getTranslatedGeoVariableName(
  indicatorClass: IndicatorClass,
  geoVariable: string,
  intl: IntlShape
) {
  let jsonGeoVarName = getGeoVariableName(indicatorClass, geoVariable)
  let version = null
  if (!jsonGeoVarName) {
    version = extractVersionFromGeoVariable(geoVariable)
    const geoVarNameWithoutVersion = geoVariable.replace(/_[^_]+\.json$/, "_public.json")
    jsonGeoVarName = getGeoVariableName(
      indicatorClass,
      geoVarNameWithoutVersion
    )
    if (!jsonGeoVarName) {
      console.error("Could not resolve geoVarName for ", geoVarNameWithoutVersion)
      return geoVariable // fallback: show raw JSON path
    }
  }
  const translatedGeoVarName = extractOptionalTranslation({
    parentKey: "variableNames",
    subKey: jsonGeoVarName,
    intl,
  })
  if (version) {
    return translatedGeoVarName + " - " + version
  } else {
    return translatedGeoVarName
  }
}

export const VariableDropdown = (props: AppState) => {
  const intl = useIntl()
  const handleChange = (event: any) => {
    const geoVariable = event.target.value

    globalStore.dispatch(actions.setGeoVariable(geoVariable))
  }

  const { linkStart, linkEnd } = selectInfoLink(
    props.indicatorClass,
    props.geoVariable!
  )

  const geoVariableArray = getGeoVariableArray(props.indicatorClass)
  const allVariables: string[] = geoVariableArray.includes(
    props.geoVariable ?? ""
  )
    ? geoVariableArray
    : [...geoVariableArray, props.geoVariable!]

  return (
    <div
      style={{
        width: "80%",
        display: "flex",
        alignItems: "center",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      <FormControl style={{ width: "100%" }}>
        <InputLabel htmlFor="variable-native-helper">
          <FormattedMessage id={"dropdown.selectVar"} />
        </InputLabel>
        <GenericSelect
          multiple={false}
          value={props.geoVariable ?? ""}
          onChange={handleChange}
          name={"variable"}
          id="variable-native-helper"
        >
          {allVariables.map((variable, index) => {
            return (
              <option key={variable} value={variable}>
                {getTranslatedGeoVariableName(
                  props.indicatorClass,
                  variable,
                  intl
                )}
              </option>
            )
          })}
        </GenericSelect>
      </FormControl>
      <a
        href={
          !linkEnd && props.indicatorClass === "EWM-AT"
            ? "https://gcci-documentation.gitbook.io/gcci-content-and-references-information/ewm-at-content-and-references-ewm-extreme-weather-monitoring-domain-austria"
            : !linkEnd && props.indicatorClass === "EWM-EUR"
            ? "https://gcci-documentation.gitbook.io/gcci-content-and-references-information/ewm-eur-content-and-references-ewm-extreme-weather-monitoring-domain-europe"
            : `https://gcci-documentation.gitbook.io/gcciv1.2-content-and-references-information/${linkStart}/${linkEnd}`
        }
        target="_blank"
        style={{ marginLeft: "20px" }}
      >
        {/* <BsInfoCircle size="1.2em" className="mr-2" /> */}
        <img src={infoIcon} style={{ width: "30px", height: "30px" }} />
      </a>
    </div>
  )
}
